
















import { defineComponent, reactive } from '@vue/composition-api';

import useDownloadReport from '@/useDownloadReport';

const AreaIncomeReport = defineComponent({
  setup() {
    const { getCSVReport } = useDownloadReport();
    const filter = reactive({
      range: {
        from: undefined,
        to: undefined,
      },
    });

    return {
      filter,
      getCSVReport,
    };
  },
});

export default AreaIncomeReport;
